import React, { useEffect, useRef } from 'react';
import { View, Image, ImageBackground, StyleSheet, Text } from 'react-native'
import { Card } from 'react-native-elements'
import { ProgressBar } from 'react-native-web';
import { TouchableOpacity } from 'react-native-gesture-handler';
import TextZ from './TextZ';
import LinearProgress from 'react-native-elements/dist/linearProgress/LinearProgress';

const PADDING = 15;

const grade = perc => {
    switch(true) {
        case perc < 10: return 'F'
        case perc < 30: return 'E'
        case perc < 60: return 'D'
        case perc < 85: return 'C'
        case perc < 95: return 'B'
        default: 
            return 'A';
    }
}

const config = {
    A: { color1: "rgba(127,255,0,0.4)", color2: "rgba(127,255,0,1)", color3: '#000000' },
    B: { color1: "rgba(127,255,0,0.4)", color2: "rgba(127,255,0,1)",  color3: '#000000' },
    C: { color1: "rgba(255,215,0,0.4)", color2: "rgba(255,215,0,1)",  color3: '#000000' },
    D: { color1: "rgba(255,215,0,0.4)", color2: "rgba(255,215,0,1)",  color3: '#000000' },
    E: { color1: "rgba(220,20,60,0.4)", color2: "rgba(220,20,60,1)",  color3: '#ffffff' },
    F: { color1: "rgba(0,0,0,0.5)", color2: "rgba(0,0,0,1)",  color3: '#ffffff' },
}

function useTraceUpdate(props) {
    const prev = useRef(props);
    useEffect(() => {
      const changedProps = Object.entries(props).reduce((ps, [k, v]) => {
        if (prev.current[k] !== v) {
          ps[k] = [prev.current[k], v];
        }
        return ps;
      }, {});
      if (Object.keys(changedProps).length > 0) {
        console.log('Changed props:', changedProps);
      } else {
        console.log('Changed props: none ?');
      }
      prev.current = props;
    });
}

const IMAGE_RATIO = 1

export default (props) => {
    const { blocked, perc, name, img, width, openSetting, imageRatio = 1, circleRatio = 0.7 } = props;

    // useTraceUpdate(props)
    // console.log(img)
    const gra = blocked ? grade(23) : grade(perc)
    const conf = config[gra]

    const height = Math.round(width*0.7* imageRatio - PADDING)

    return <TouchableOpacity style={[styles.container, {
        height: Math.floor(width*0.95 * imageRatio + PADDING + PADDING),
        width: Math.floor(width*0.95),
    }]}
    onPress={() => { blocked ? openSetting() : null}}
    >
      <Card containerStyle={{ borderRadius: 10, background: '#222222', borderColor: '#444444' }} style={[styles.container, {
        height: Math.floor(width*0.95 * imageRatio),
        width: Math.floor(width*0.95),
      }]}>
        <Card.Title style={{ marginBottom: 0 }}>
          <TextZ style={styles.title}>{blocked ? '[ เฉพาะ VIP ]' : name}</TextZ>
        </Card.Title>
        <ImageBackground
            source={img}
            style={{
                height,
                width: Math.round(width*0.8 - PADDING),
                alignItems: 'center',
                alignContent: 'center',
                paddingTop: Math.floor(height * 0.2),
                backgroundColor: '#0201202'
            }}
            imageStyle={blocked ? { filter: 'grayscale(100%)', backgroundColor: '#0201202' } : { backgroundColor: '#0201202' } }
            resizeMode="contain"
        />
 
        <View style={[styles.progressContainer, {
            width: Math.round(width*0.8-PADDING)
        }]}>
            <ProgressBar 
                style={[styles.progressProgress, styles[`progress${gra}`]]}
                progress={blocked ? 0 : perc/100}
                animating={true} 
                color={conf.color2} 
                trackColor={conf.color1} 
            />
            <View style={[styles.progressPercent]}>
                <TextZ style={[ { color: "#aa0000", }]}>โอกาส : </TextZ>
                <TextZ style={[ { color: conf.color3, }]}>{blocked ? 'เฉพาะ VIP' : `${perc}%`}</TextZ>
            </View>
        </View>
        
      </Card>
    </TouchableOpacity>;
}
 
const styles = StyleSheet.create({
    container: {
        // paddingTop: PADDING,
        paddingBottom: PADDING * 2,
        alignItems: 'center',
        
    },
    percent: {
        borderRadius: '50%', 
    },
    title: { 
        fontWeight: 'light', 
        fontFamily: 'Prompt-Light',
        fontSize: 16, 
        whiteSpace: 'nowrap', 
        color: '#ffffff',
    },
    progressContainer: {
        marginTop: 8,
        height: 20,
        backgroundColor: "#ffffff", 
        width: '100%',
    },
    progressProgress: {
        height: 20,
        backgroundColor: `rgba(9,181,0,1)`
    },
    progressPercent: {
        // color: '#ffffff',
        position: 'absolute',
        top: 0,
        left: 0,
        // lineHeight: 20,
        // fontWeight: 'bold',
        paddingLeft: 5,
        flexDirection: 'row',
  
        alignItems: 'flex-end'
    }, 
    progressA: {
        background: `linear-gradient(90deg, rgba(235,255,190,1) 0%, rgba(9,241,0,1) 100%)`,
    }
});
  
  